import React from 'react';
export function ProductName() {
  return <>
      Professeur de Danse Classique{' '}
      <span className="font-script text-[1.35em] font-normal leading-none text-brand-coral" data-id="element-220" data-mp="ukyzc89ws1mg">
        Pro
      </span>
    </>;
}